import React, { useEffect, useRef, useState } from 'react';

const TrustpilotSimple = () => {
    const trustpilotWidgetRef = useRef(null);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        // Detect client environment
        setIsClient(true);
    }, []);

    useEffect(() => {
        // Initialize Trustpilot widget only if in client environment
        if (isClient) {
            const reinitializeTrustpilotWidgets = () => {
                if (window.Trustpilot && trustpilotWidgetRef.current) {
                    window.Trustpilot.loadFromElement(trustpilotWidgetRef.current, true);
                }
            };
            reinitializeTrustpilotWidgets();
        }
    }, [isClient]);

    if (!isClient) return null; // Ensures this component doesn't render on the server

    return (
        <div
            ref={trustpilotWidgetRef}
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="5419b732fbfb950b10de65e5"
            data-businessunit-id="58bff1ac0000ff00059e0e97"
            data-style-height="24px"
            data-style-width="100%">
            <a href="https://uk.trustpilot.com/review/holbornassets.com" target="_blank" rel="noopener">Trustpilot</a>
        </div>
    );
};

export default TrustpilotSimple;